import { translate, type TranslationReplacement, type TranslationReplacements } from "app/filters/i18nFilter";
import type { Translatable } from "app/pages/sales-intelligence/types";

export const tryTranslate = (key: string): string | undefined => {
    const value = translate(key);

    return value === key ? undefined : value;
};

function isTranslatableReplacement(
    replacement?: TranslationReplacement | Readonly<Translatable>,
): replacement is Translatable {
    return typeof (replacement as Translatable)?.key !== "undefined";
}

export function translateNested(translatable: Readonly<Translatable>) {
    const { key, replacements = {} } = translatable;
    const replacementsKeys = Object.keys(replacements);

    if (replacementsKeys.length === 0) {
        return translate(key, replacements as TranslationReplacements);
    }

    const translatableCopy = { key, replacements: { ...replacements } };
    const singleLevelTranslatable = Object.keys(translatableCopy.replacements).reduce<Required<Translatable>>(
        (acc, replacementKey) => {
            const replacement = translatableCopy.replacements[replacementKey];

            if (isTranslatableReplacement(replacement)) {
                acc.replacements[replacementKey] = translateNested(replacement);
            } else {
                acc.replacements[replacementKey] = replacement;
            }

            return acc;
        },
        { key, replacements: {} },
    );

    return translate(singleLevelTranslatable.key, singleLevelTranslatable.replacements as TranslationReplacements);
}
